import { takeEvery, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
    FETCH_MASTER_MAPPING_REQUEST,
    fetchMasterMappingSuccess,
    fetchMasterMappingFailure,
    FETCH_DETAILS_REQUEST,
    fetchDetailsSuccess,
    fetchDetailsFailure,
    FETCH_REPORT_GROUP_REQUEST,
    fetchReportGroupSuccess,
    fetchReportGroupFailure,
    FETCH_REPORT_FS_NOTES_REQUEST,
    fetchReportFSNotesSuccess,
    fetchReportFSNotesFailure,
    FETCH_REPORT_FS_LINES_REQUEST,
    fetchReportFSLinesSuccess,
    fetchReportFSLinesFailure,
    FETCH_REPORT_AGGREGATE_REQUEST,
    fetchReportAggregateSuccess,
    fetchReportAggregateFailure,
    FETCH_REPORT_TESTING_SHEET_REQUEST,
    fetchReportTestingSheetSuccess,
    fetchReportTestingSheetFailure,
    FETCH_REPORT_CAP_REQUEST,
    fetchReportCAPSuccess,
    fetchReportCAPFailure,
    FETCH_REPORT_PAP_REQUEST,
    fetchReportPAPSuccess,
    fetchReportPAPFailure,
} from './actions';
import {
    BASE_API_URL,
    MASTER_MAPPING_API_URL,
    GET_DETAILS_API_URL,
    GET_REPORT_GROUP_API_URL,
    GET_REPORT_FS_NOTES_API_URL,
    GET_REPORT_FS_LINES_API_URL,
    GET_REPORT_AGGREGATE_API_URL,
    GET_REPORT_TESTING_SHEET_API_URL,
    GET_REPORT_CAP_API_URL,
    GET_REPORT_PAP_API_URL,
} from '../config';

function* fetchMasterMappingSaga() {
    try {
        const response = yield call(axios.get, `${BASE_API_URL}/${MASTER_MAPPING_API_URL}`);
        yield put(fetchMasterMappingSuccess(response.data));
    } catch (error) {
        yield put(fetchMasterMappingFailure(error.message));
    }
}

function* fetchDetailsSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_DETAILS_API_URL}/${engagementCode}`,
            { params: { branchSubCode: branchSubCode } }
        );
        yield put(fetchDetailsSuccess(response.data));
    } catch (error) {
        yield put(fetchDetailsFailure(error.message));
    }
}

function* fetchReportGroupSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_GROUP_API_URL}/${engagementCode}/${branchSubCode}`
        );
        yield put(fetchReportGroupSuccess(response.data));
    } catch (error) {
        yield put(fetchReportGroupFailure(error.message));
    }
}

function* fetchReportFSNotesSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_FS_NOTES_API_URL}/${engagementCode}/${branchSubCode}`,
        );
        yield put(fetchReportFSNotesSuccess(response.data));
    } catch (error) {
        yield put(fetchReportFSNotesFailure(error.message));
    }
}

function* fetchReportFSLinesSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_FS_LINES_API_URL}/${engagementCode}/${branchSubCode}`,
        );
        yield put(fetchReportFSLinesSuccess(response.data));
    } catch (error) {
        yield put(fetchReportFSLinesFailure(error.message));
    }
}

function* fetchReportAggregateSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_AGGREGATE_API_URL}/${engagementCode}/${branchSubCode}`,
        );
        yield put(fetchReportAggregateSuccess(response.data));
    } catch (error) {
        yield put(fetchReportAggregateFailure(error.message));
    }
}

function* fetchReportTestingSheetSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_TESTING_SHEET_API_URL}/${engagementCode}/${branchSubCode}`,
        );
        yield put(fetchReportTestingSheetSuccess(response.data));
    } catch (error) {
        yield put(fetchReportTestingSheetFailure(error.message));
    }
}

function* fetchReportCAPSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_CAP_API_URL}/${engagementCode}/${branchSubCode}`,
        );
        yield put(fetchReportCAPSuccess(response.data));
    } catch (error) {
        yield put(fetchReportCAPFailure(error.message));
    }
}

function* fetchReportPAPSaga(action) {
    const { engagementCode, branchSubCode } = action.payload;
    try {
        const response = yield call(
            axios.get,
            `${BASE_API_URL}/${GET_REPORT_PAP_API_URL}/${engagementCode}/${branchSubCode}`,
        );
        yield put(fetchReportPAPSuccess(response.data));
    } catch (error) {
        yield put(fetchReportPAPFailure(error.message));
    }
}

function* rootSaga() {
    yield takeEvery(FETCH_MASTER_MAPPING_REQUEST, fetchMasterMappingSaga);
    yield takeEvery(FETCH_DETAILS_REQUEST, fetchDetailsSaga);
    yield takeEvery(FETCH_REPORT_GROUP_REQUEST, fetchReportGroupSaga);
    yield takeEvery(FETCH_REPORT_FS_NOTES_REQUEST, fetchReportFSNotesSaga);
    yield takeEvery(FETCH_REPORT_FS_LINES_REQUEST, fetchReportFSLinesSaga);
    yield takeEvery(FETCH_REPORT_AGGREGATE_REQUEST, fetchReportAggregateSaga);
    yield takeEvery(FETCH_REPORT_TESTING_SHEET_REQUEST, fetchReportTestingSheetSaga);
    yield takeEvery(FETCH_REPORT_CAP_REQUEST, fetchReportCAPSaga);
    yield takeEvery(FETCH_REPORT_PAP_REQUEST, fetchReportPAPSaga);
}

export default rootSaga;
